module.exports = __webpack_public_path__ + "static/media/arrow-left.33e71fea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-left.svg
// module id = 1544
// module chunks = 0